/* eslint-disable no-nested-ternary */
/* eslint-disable indent */
/* eslint-disable complexity */
// Libraries
import { FormElems, Alert } from '../';
import {
    updateIntentRequest,
    updateIntentError,
} from '../../containers/RoleVerification/redux/roleVerification.actions';
import { VERIFICATION_MESSAGE } from '../../utils/constants/toastMessages';
import { INPROCESS } from '../../components/Table/table.constants';
import { getIntent } from '../../utils/helperMethods';
import validate from './validator';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import moment from 'moment';

// Components

// Actions

// Validator

// Styles
import './userVerificationForm.scss';

const UserVerificationForm = props => {
    const {
        actions,
        handleSubmit,
        closePopup,
        data,
        roleStatus,
        roleVerificationData,
    } = props;

    const { updateIntent } = roleVerificationData;

    const isInProcess = roleStatus === INPROCESS;

    useEffect(() => {
        if (updateIntent.isSuccess) {
            closePopup(true);
            toast.info(VERIFICATION_MESSAGE.STATUS_UPDATE);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updateIntent.isSuccess]);

    useEffect(() => {
        return () => {
            actions.updateIntentError({ error: {}, isSuccess: false });
        };
    }, [actions]);

    const handleFormSubmit = values => {
        if (values.userAction === 'approve') {
            actions.updateIntentRequest({
                requestId: data.requestId,
                comment: values.comment,
                action: 'APPROVED',
            });
        }

        if (values.userAction === 'reject') {
            actions.updateIntentRequest({
                requestId: data.requestId,
                comment: values.comment,
                action: 'REJECTED',
            });
        }
    };

    return (
        <form className="user-verification-view">
            <div className="form-section">
                <div className="form-field status-section">
                    <p className="label">Status</p>
                    <div className="lastupdate-status">
                        {/* {data.userUpdatedByName && (
                            <>
                                Last Edit :{' '}
                                <strong>{data.userUpdatedByName}</strong>,{' '}
                                {moment(data.userCreatedDate, 'DD/MM/YYYY')
                                    .calendar()
                                    .indexOf('Today') >= 0
                                    ? 'Today'
                                    : moment(data.userCreatedDate, 'DD/MM/YYYY')
                                          .calendar()
                                          .indexOf('Yesterday') >= 0
                                    ? 'Yesterday'
                                    : data.userCreatedDate}
                            </>
                        )} */}
                        {data.userCreatedUpdate && (
                            <>
                                {getIntent(data.lastActions)}{' '}
                                <strong>{data.userCreatedUpdate}</strong>,{' '}
                                {moment(data.userCreatedDate, 'DD/MM/YYYY')
                                    .calendar()
                                    .indexOf('Today') >= 0
                                    ? 'Today'
                                    : moment(data.userCreatedDate, 'DD/MM/YYYY')
                                          .calendar()
                                          .indexOf('Yesterday') >= 0
                                    ? 'Yesterday'
                                    : data.userCreatedDate}
                            </>
                        )}
                    </div>
                    {data.userStatus ? (
                        <div className={`status ${data.userStatus}`}>
                            <span className="text-simple">
                                {data.userStatus}
                            </span>
                            {data.userStatusOld &&
                            data.userStatus !== data.userStatusOld ? (
                                <span className="strike-through">
                                    {data.userStatusOld}
                                </span>
                            ) : null}
                        </div>
                    ) : (
                        <span className="text-simple">-</span>
                    )}
                </div>
            </div>
            <div className="form-section change-section">
                <div className="form-field">
                    <p className="label">Email ID</p>
                    <p className="user-text email" title={data.email}>
                        <span className="text-simple">{data.email || '-'}</span>
                    </p>
                </div>
            </div>
            <div className="form-section change-section">
                <div className="form-field">
                    <p className="label">Role</p>
                    <p className="user-text">
                        <span className="text-simple">
                            {data.userRoleName || '-'}
                        </span>
                        {data.userRoleNameOld &&
                        data.userRoleNameOld !== data.userRoleName ? (
                            <span className="strike-through">
                                {data.userRoleNameOld}
                            </span>
                        ) : null}
                    </p>
                </div>
                <div className="form-field">
                    <p className="label">User Level</p>
                    <p className="user-text email" title={data.userLevel}>
                        <span className="text-simple">
                            {data.userLevel || '-'}
                        </span>
                        {data.userLevelOld &&
                        data.userLevelOld !== data.userLevel ? (
                            <span className="strike-through">
                                {data.userLevelOld}
                            </span>
                        ) : null}
                    </p>
                </div>
            </div>
            <div className="form-section change-section">
                <div className="form-field">
                    <p className="label">{data.userLevel}</p>
                    <p className="user-text email" title={data.entityName}>
                        <span className="text-simple">{data.entityName}</span>
                        {data.entityNameOld &&
                        data.entityName !== data.entityNameOld ? (
                            <span className="strike-through">
                                {data.entityNameOld}
                            </span>
                        ) : null}
                    </p>
                </div>
            </div>
            <div className="form-section comment-box">
                <p className="label">Comment</p>
                {data.checkerComment
                    ? data.checkerComment
                    : data.makerComment || '-'}
            </div>
            {isInProcess ? (
                <div className="form-section comment-box borderless">
                    <p className="label">Comment</p>
                    <Field
                        wrapperClass="comment-input"
                        name="comment"
                        type="textarea"
                        component={FormElems.TextArea}
                        placeholder="Enter Comment "
                    />
                </div>
            ) : null}
            {updateIntent.error && updateIntent.error.errorMessage ? (
                <Alert>{updateIntent.error.errorMessage}</Alert>
            ) : null}
            <div className="form-section action">
                {isInProcess ? (
                    <>
                        <FormElems.Button
                            buttonType="secondary"
                            customClass="cancel-button"
                            text="REJECT"
                            type="button"
                            handleClick={handleSubmit(values => {
                                handleFormSubmit({
                                    ...values,
                                    userAction: 'reject',
                                });
                            })}
                        />
                        <FormElems.Button
                            buttonType="primary"
                            text="APPROVE"
                            type="button"
                            handleClick={handleSubmit(values => {
                                handleFormSubmit({
                                    ...values,
                                    userAction: 'approve',
                                });
                            })}
                        />
                    </>
                ) : null}
            </div>
        </form>
    );
};

const mapStateToProps = ({ auth, form, roleVerificationData }) => ({
    auth,
    roleVerificationData,
    formData: form['user-verification'],
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            updateIntentRequest,
            updateIntentError,
        },
        dispatch
    ),
});

UserVerificationForm.propTypes = {
    actions: PropTypes.object,
    handleSubmit: PropTypes.func,
    closePopup: PropTypes.func,
    data: PropTypes.object,
    roleStatus: PropTypes.string,
    roleVerificationData: PropTypes.object,
    auth: PropTypes.object,
};

export default compose(
    reduxForm({
        form: 'user-verification',
        validate,
    }),
    connect(mapStateToProps, mapDispatchToProps)
)(UserVerificationForm);
